import React from 'react';


const SearchResults = ({ publishers }) => {
  return (
    <div id="publisherslist" className='mt-25'>
      {publishers.map(publisher => (
          <div className="publishers-row" key={publisher.id}>
            <div className="col-md-12 publishers-col">
              <h5 className="text-black">{publisher.name}</h5>
            </div>
          </div>
        ))}
    </div>
  );
};

export default SearchResults;